module.exports = __webpack_public_path__ + "static/media/20ECE12.9f5b385a.jpg";